import MissionEndStatus from '../enums/mission-status';
import Deployment, { mockDeployment } from '../organization/deployment';

interface MissionList {
  id: string;
  deployment: Deployment;
  duration: number;
  cleanedArea: number;
  startTime: string; // iso string
  missionEndStatus: MissionEndStatus;
  timezone: string;
  roomName: string | null;
  isTransition: boolean;
}

export default MissionList;

export const isMissionList = (input: any): input is MissionList => {
  return 'deployment' in input && 'duration' in input && 'missionEndStatus' in input;
};

export const mockMissionList = {
  id: 'e701c79b-e5e1-4053-be7a-048ee4605a6f',
  deployment: mockDeployment,
  duration: 218.0,
  roomName: null,
  missionEndStatus: MissionEndStatus.SUCCEEDED,
  startTime: '2024-07-09T14:22:03',
  isTransition: false,
} as MissionList;

export const mockMissionList2 = {
  id: 'anotherId',
  isTransition: false,
  deployment: mockDeployment,
  duration: 123.0,
  roomName: 'Eschlikon',
  missionEndStatus: MissionEndStatus.SUCCEEDED,
  startTime: '2024-07-09T14:22:03',
} as MissionList;
